export type RenderedImageBox = {
  width: number;
  height: number;
  naturalSize: { width: number; height: number } | null;
};

import { IMAGE_LAYOUT_CSS } from '../domain/image-layout';

function readNaturalSize(
  target: Element,
): { width: number; height: number } | null {
  const img =
    target instanceof HTMLImageElement
      ? target
      : target.querySelector(
          `img.${IMAGE_LAYOUT_CSS.bgFallback}, img[alt]:not(.${IMAGE_LAYOUT_CSS.bgFallback})`,
        );
  if (
    img instanceof HTMLImageElement &&
    img.naturalWidth > 0 &&
    img.naturalHeight > 0
  ) {
    return { width: img.naturalWidth, height: img.naturalHeight };
  }
  return null;
}

export function findImageMeasureTarget(container: HTMLElement): Element | null {
  const autoImg = container.querySelector(
    `img[alt]:not(.${IMAGE_LAYOUT_CSS.bgFallback})`,
  );
  if (autoImg instanceof Element) {
    return autoImg;
  }
  return (
    container.querySelector(`table.${IMAGE_LAYOUT_CSS.fixed}`) ??
    container.querySelector(`table.${IMAGE_LAYOUT_CSS.fillCol}`) ??
    container.querySelector(`img.${IMAGE_LAYOUT_CSS.bgFallback}`)
  );
}

export function measureRenderedImageBox(
  blockId: string,
): RenderedImageBox | null {
  const frame = document.querySelector(`[data-entity-id="block:${blockId}"]`);
  const root = frame?.querySelector<HTMLElement>('[data-image-block="true"]');
  const content = root?.firstElementChild;
  if (!(content instanceof HTMLElement)) {
    return null;
  }
  const target = findImageMeasureTarget(content);
  if (!target) {
    return null;
  }
  const rect = target.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) {
    return null;
  }
  return {
    width: rect.width,
    height: rect.height,
    naturalSize: readNaturalSize(target),
  };
}
